import { ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Project components
import URLS from 'URLS';
import Demo from 'containers/Landing/components/Demo';

// MUI components
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const DemoWithSelector = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  // Define demo options
  const demoOptions = [
    {
      demoImage:
        'https://firebasestorage.googleapis.com/v0/b/ec-play-prod.appspot.com/o/landing%2Fvideos%2FplayerDemos%2FBand%20Demo.gif?alt=media&token=74ae2110-b131-4eb1-a5f0-0b02ea4417a8',
      label: 'band',
    },
    {
      demoImage:
        'https://firebasestorage.googleapis.com/v0/b/ec-play-prod.appspot.com/o/landing%2Fvideos%2FplayerDemos%2FPiano%20Demo.gif?alt=media&token=ada40b07-1e00-4386-9abc-86949ea94840',
      label: 'whitepiano',
    },
    {
      demoImage:
        'https://firebasestorage.googleapis.com/v0/b/ec-play-prod.appspot.com/o/landing%2Fvideos%2FplayerDemos%2FGuitar%20Demo.gif?alt=media&token=e8019594-73d0-460e-b8c5-96de8e106a78',
      label: 'guitar',
    },
    {
      demoImage:
        'https://firebasestorage.googleapis.com/v0/b/ec-play-prod.appspot.com/o/landing%2Fvideos%2FplayerDemos%2FUkulele%20Demo.gif?alt=media&token=d1d82b4a-ba82-4839-a7dd-c7fa3700aaab',
      label: 'ukulele',
    },
    {
      demoImage:
        'https://firebasestorage.googleapis.com/v0/b/ec-play-prod.appspot.com/o/landing%2Fvideos%2FplayerDemos%2FBoomWhackers%20Demo.gif?alt=media&token=a9c3c6eb-9e4a-49fd-9757-06a73b4f940a',
      label: 'boomwhackers',
    },
    {
      demoImage:
        'https://firebasestorage.googleapis.com/v0/b/ec-play-prod.appspot.com/o/landing%2Fvideos%2FplayerDemos%2FBassTabs%20Demo.gif?alt=media&token=b5687dc6-f5d2-4b2d-b51b-77bc869a38ce',
      label: 'basstabs',
    },
    {
      demoImage:
        'https://firebasestorage.googleapis.com/v0/b/ec-play-prod.appspot.com/o/landing%2Fvideos%2FplayerDemos%2FChoir%20Demo.gif?alt=media&token=d0c0ba0f-058a-43b8-b5f3-7da9ff7982d6',
      label: 'choir',
    },
  ];

  const [selectedDemo, setSelectedDemo] = useState(demoOptions[0]);

  const handleDemoChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedLabel = event.target.value;
    const demo = demoOptions.find((option) => option.label === selectedLabel);
    if (demo) {
      setSelectedDemo(demo);
    }
  };

  const handleDemoClick = () => {
    const url = URLS.PLAYER_DEMO + '/' + selectedDemo.label;
    navigate(url);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4, width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '90%', maxWidth: '600px', height: '56px' }}>
        <TextField fullWidth label={t('LANDING.CHOOSEDEMO')} onChange={handleDemoChange} select value={selectedDemo.label} variant='outlined'>
          {demoOptions.map((option) => (
            <MenuItem key={option.label} value={option.label}>
              {t('APPS.' + option.label.toUpperCase())}
            </MenuItem>
          ))}
        </TextField>
        <Button color='primary' onClick={handleDemoClick} sx={{ minWidth: '110px', height: '100%' }} variant='contained'>
          <Typography>{t('LANDING.TRYDMEO')}</Typography>
        </Button>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, width: '100%' }}>
        <Demo content={selectedDemo.demoImage} onClick={handleDemoClick} />
      </Box>
    </Box>
  );
};

export default DemoWithSelector;
